export const Collapse = {
  'zh-CN': {
    title: '折叠面板',
    addCollapsePanel: '添加面板',
    settings: {
      'x-component-props': {
        accordion: '手风琴模式',
        collapsible: { title: '可折叠区域', dataSource: ['头部', '禁用'] },
        ghost: '幽灵模式',
        bordered: '是否有边框',
      },
    },
  },
}

export const CollapsePanel = {
  'zh-CN': {
    title: '面板',
    settings: {
      'x-component-props': {
        collapsible: { title: '是否可折叠', dataSource: ['头部', '禁用'] },
        header: '标题',
        extra: '扩展内容',
        disabled: '是否禁用'
      },
    },
  },
  'en-US': {
    title: 'Panel',
    settings: {
      'x-component-props': {
        collapsible: {
          title: 'Collapsible',
          dataSource: ['Header', 'Disable'],
        },
        header: 'Header Title',
        extra: 'Extra Content',
      },
    },
  },
  'ko-KR': {
    title: '패널',
    settings: {
      'x-component-props': {
        collapsible: {
          title: '드롭 여부',
          dataSource: ['해더', '비활성화'],
        },
        header: '헤더 제목',
        extra: '추가 내용',
      },
    },
  },
}
